import Vue from 'vue'
import Vuex from 'vuex'
import brochure from './modules/brochure'
import application from './modules/application'
import ovb from './modules/ovb'
import apolloErrors from './modules/apolloErrors'
import activitiesBrowsers from './modules/activitiesBrowsers'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    refresh: false
  },
  mutations: {
    refresh (state) {
      state.refresh = !state.refresh
    }
  },
  actions: {
    recordException (store, payload) {
      console.error('GraphQL error:', payload)
    }
  },
  modules: {
    application,
    ovb,
    brochure,
    apolloErrors,
    activitiesBrowsers
  }
})
